import L from 'leaflet';
import {featureLayer, dynamicMapLayer} from 'esri-leaflet';
import {service} from 'esri-leaflet-gp';
import {geosearch, geocodeService} from 'esri-leaflet-geocoder';

// leaflet draw editable layers
var editableLayers = new L.FeatureGroup();
    // map.addLayer(editableLayers);

var MyCustomMarker = L.Icon.extend({
    options: {
        shadowUrl: null,
        iconAnchor: new L.Point(12, 12),
        iconSize: new L.Point(24, 24),
        iconUrl: require('leaflet/dist/images/marker-icon.png')
    }
});

var drawOptions = {
    polyline: {
      shapeOptions: {
        color: '#f357a1',
        weight: 10
      }
    },
    polygon: {
      allowIntersection: false, // Restricts shapes to simple polygons
      drawError: {
        color: '#e1e100', // Color the shape will turn when intersects
        message: '<strong>Oh snap!<strong> you can\'t draw that!' // Message that will show when intersect
      },
      shapeOptions: {
        color: '#bada55'
      }
    },
    circle: {
      shapeOptions: {
        color: '#315e80'
      }
    }, // Turns off this drawing tool
    rectangle: {
      shapeOptions: {
        clickable: false
      }
    },
    marker: {
      icon: new MyCustomMarker()
    },
  edit: {
    featureGroup: editableLayers, //REQUIRED!!
    remove: true
  }
};
// drive time response polygons
var driveTimes = new L.FeatureGroup();
function driveTimeCallback(error, response, raw) {
  // document.getElementById('info-pane').innerHTML = 'click on the map to calculate 1 and 2 minute drivetimes';
  driveTimes.addLayer(L.geoJSON(response.Output_Drive_Time_Polygons));
}

var criticalAreas = featureLayer({
  url: 'https://geodata.md.gov/imap/rest/services/Environment/MD_CriticalAreas/FeatureServer/0',
  simplifyFactor: 0.5,
  precision: 5,
  style: function(feature) {
    if (feature.properties.CritArea === 'Intensely Developed Area') {
      return {color: 'Crimson', weight: 2};
    } else if (feature.properties.CritArea === 'Wetland Area') {
      return {color: 'Blue', weight: 2};
    } else if (feature.properties.CritArea === 'Corporate Limit') {
      return {color: 'DarkSlateGrey', weight: 2};
    } else if (feature.properties.CritArea === 'Resource Conservation Area') {
      return {color: 'DarkOliveGreen', weight: 2};
    } else if (feature.properties.CritArea === 'Limited Development Area') {
      return {color: 'DarkOrange', weight: 2};
    } else if (feature.properties.CritArea === 'Federal Lands') {
      return {color: 'Navy', weight: 2};
    } else {
      return {color: 'Tan', weight: 2};
    }
  }
});

var searchControl = geosearch()
//
var results = L.layerGroup();
//


// leafletMap.on(L.Draw.Event.CREATED, function (e) {
//     var type = e.layerType,
//         layer = e.layer;
//
//     if (type === 'marker') {
//         layer.bindPopup('A popup!');
//     }
//
//     editableLayers.addLayer(layer);
// });

export { MyCustomMarker, editableLayers, drawOptions, driveTimes, driveTimeCallback, criticalAreas, results, searchControl }



// WEBPACK FOOTER //
// src/js/view/map/config.js